export const languages = {
  ru: { id: 1, text: 'Русский', code: 'ru', locale: 'ru' },
  am: { id: 2, text: 'Հայերեն', code: 'am', locale: 'hy-am' },
  en: { id: 3, text: 'English', code: 'en', locale: 'en-au' },
};
